import React, { useState } from "react";
import Layout from "../components/layouts/Layout";

const MissionVisionPage = () => {
  const [activeTab, setActiveTab] = useState('mission');

  const philosophyData = {
    mission: {
      title: "AIを日常に",
      subtitle: "AI wo nichijou ni",
      description: "私たちは、AI技術を一般の人々や企業の日常生活に溶け込ませ、AIが特別な技術ではなく、誰もが使いこなせるツールとなることを目指します。",
      details: [
        "AIの民主化により、技術格差を解消する",
        "日常業務にAIを自然に統合し、生産性を向上させる", 
        "AI技術を通じて、人々の創造性と可能性を最大化する",
        "専門知識がなくても使える、直感的なAIソリューションを提供する"
      ]
    },
    vision: {
      title: "日本のAIリテラシーを底上げ。経済のスピードアップを目指す。",
      description: "私たちの目標は、日本人のAIリテラシーを向上させ、生産性をアップさせる方法を提供することです。AIが手助けし、業務時間を軽減させ、人材を新しい事業などに当てるようになってほしいです。",
      goals: [
        "2025年までに日本企業1,000社にAI導入を実現",
        "AIリテラシー向上プログラムで10,000人の人材育成",
        "業界平均50%の生産性向上を実現",
        "地方創生とAI技術を組み合わせた新しいビジネスモデルの創出"
      ]
    },
    values: [
      {
        title: "営業しない：関係構築を最優先に",
        description: "押し売りや強引な営業は行いません。お客様との長期的な信頼関係を築き、本当に必要なソリューションを提供します。",
        icon: "PARTNERSHIP"
      },
      {
        title: "具体的である：実績や事例を提示",
        description: "曖昧な表現ではなく、具体的な数値や実績を基にした提案を行います。透明性を重視し、期待値を正確に伝えます。",
        icon: "DATA"
      },
      {
        title: "顧客の成功に寄り添う：顧客の成功を最優先に",
        description: "私たちの成功は、お客様の成功があってこそ。お客様のビジネス成長を第一に考え、長期的なパートナーシップを築きます。",
        icon: "SUCCESS"
      }
    ]
  };

  const founderPhilosophy = {
    background: "60年代のカウンターカルチャーの逆パターンとして、現代は多様性に対しての反発が見られる時代。正解が決められていた時代から、個々人が決めた正解に最適化する時代への転換期にある。",
    beliefs: [
      "バタフライ効果：小さな変化が大きな影響を与える可能性を信じる",
      "一元論：感覚として、すべては繋がっているという世界観",
      "改革意識と危機感：誰かやるだろうでは、何も起こらない",
      "技術・経営・海外の3軸で世界を変える"
    ],
    quote: "Be daring, Be first, Be different（勇気を持って、誰よりも早く、人と違うことを）"
  };

  return (
    <Layout 
      title="Mission / Vision" 
      subtitle="DeepTeLLの理念と目指す未来についてご紹介します"
    >
      {/* タブナビゲーション */}
      <section style={{ padding: '60px 0 40px', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <div style={{ display: 'inline-flex', background: 'rgba(30, 41, 59, 0.8)', borderRadius: '8px', padding: '4px' }}>
                  <button
                    className={`btn ${activeTab === 'mission' ? 'btn-custom' : 'btn-outline'}`}
                    onClick={() => setActiveTab('mission')}
                    style={{ 
                      margin: '4px',
                      background: activeTab === 'mission' ? '#3b82f6' : 'transparent',
                      color: activeTab === 'mission' ? 'white' : '#cbd5e1'
                    }}
                  >
                    ミッション
                  </button>
                  <button
                    className={`btn ${activeTab === 'vision' ? 'btn-custom' : 'btn-outline'}`}
                    onClick={() => setActiveTab('vision')}
                    style={{ 
                      margin: '4px',
                      background: activeTab === 'vision' ? '#3b82f6' : 'transparent',
                      color: activeTab === 'vision' ? 'white' : '#cbd5e1'
                    }}
                  >
                    ビジョン
                  </button>
                  <button
                    className={`btn ${activeTab === 'values' ? 'btn-custom' : 'btn-outline'}`}
                    onClick={() => setActiveTab('values')}
                    style={{ 
                      margin: '4px',
                      background: activeTab === 'values' ? '#3b82f6' : 'transparent',
                      color: activeTab === 'values' ? 'white' : '#cbd5e1'
                    }}
                  >
                    バリュー
                  </button>
                  <button
                    className={`btn ${activeTab === 'philosophy' ? 'btn-custom' : 'btn-outline'}`}
                    onClick={() => setActiveTab('philosophy')}
                    style={{ 
                      margin: '4px',
                      background: activeTab === 'philosophy' ? '#3b82f6' : 'transparent',
                      color: activeTab === 'philosophy' ? 'white' : '#cbd5e1'
                    }}
                  >
                    創業者の思想
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ミッション */}
      {activeTab === 'mission' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2" style={{ textAlign: 'center' }}>
                <div className="premium-card" style={{ 
                  padding: '60px 40px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px',
                  marginBottom: '40px'
                }}>
                  <h2 style={{ color: '#3b82f6', marginBottom: '20px', fontSize: '36px' }}>
                    {philosophyData.mission.title}
                  </h2>
                  <p style={{ color: '#94a3b8', fontSize: '18px', marginBottom: '30px', fontStyle: 'italic' }}>
                    {philosophyData.mission.subtitle}
                  </p>
                  <p style={{ color: '#cbd5e1', fontSize: '18px', lineHeight: '1.8', marginBottom: '40px' }}>
                    {philosophyData.mission.description}
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              {philosophyData.mission.details.map((detail, index) => (
                <div key={index} className="col-md-6" style={{ marginBottom: '30px' }}>
                  <div style={{ 
                    padding: '30px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ 
                        width: '40px',
                        height: '40px',
                        background: '#3b82f6',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: '15px',
                        color: 'white',
                        fontWeight: 'bold'
                      }}>
                        {index + 1}
                      </div>
                      <h4 style={{ color: '#f1f5f9', margin: 0 }}>重点領域 {index + 1}</h4>
                    </div>
                    <p style={{ color: '#cbd5e1', lineHeight: '1.6' }}>{detail}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ビジョン */}
      {activeTab === 'vision' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2" style={{ textAlign: 'center' }}>
                <div className="premium-card" style={{ 
                  padding: '60px 40px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px',
                  marginBottom: '50px'
                }}>
                  <h2 style={{ color: '#3b82f6', marginBottom: '30px', fontSize: '28px', lineHeight: '1.4' }}>
                    {philosophyData.vision.title}
                  </h2>
                  <p style={{ color: '#cbd5e1', fontSize: '18px', lineHeight: '1.8' }}>
                    {philosophyData.vision.description}
                  </p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12" style={{ textAlign: 'center', marginBottom: '40px' }}>
                <h3 style={{ color: '#f1f5f9', marginBottom: '30px' }}>🎯 具体的な目標</h3>
              </div>
            </div>

            <div className="row">
              {philosophyData.vision.goals.map((goal, index) => (
                <div key={index} className="col-md-6" style={{ marginBottom: '30px' }}>
                  <div style={{ 
                    padding: '30px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(16, 185, 129, 0.2)',
                    borderRadius: '12px',
                    borderLeft: '4px solid #10b981'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ fontSize: '24px', marginRight: '15px' }}>🚀</div>
                      <h4 style={{ color: '#10b981', margin: 0 }}>目標 {index + 1}</h4>
                    </div>
                    <p style={{ color: '#cbd5e1', lineHeight: '1.6' }}>{goal}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* バリュー */}
      {activeTab === 'values' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-12" style={{ textAlign: 'center', marginBottom: '50px' }}>
                <h2 style={{ color: '#3b82f6', marginBottom: '20px' }}>私たちの行動指針</h2>
                <p style={{ color: '#cbd5e1', fontSize: '18px' }}>
                  DeepTeLLの全ての活動は、この3つのバリューに基づいて行われます
                </p>
              </div>
            </div>

            <div className="row">
              {philosophyData.values.map((value, index) => (
                <div key={index} className="col-md-4" style={{ marginBottom: '40px' }}>
                  <div style={{ 
                    padding: '40px 30px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '64px', marginBottom: '20px' }}>{value.icon}</div>
                    <h3 style={{ color: '#f1f5f9', marginBottom: '20px', fontSize: '18px' }}>
                      {value.title}
                    </h3>
                    <p style={{ color: '#cbd5e1', lineHeight: '1.6', fontSize: '14px' }}>
                      {value.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* 創業者の思想 */}
      {activeTab === 'philosophy' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2">
                <div className="premium-card" style={{ 
                  padding: '40px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px',
                  marginBottom: '40px'
                }}>
                  <h2 style={{ color: '#3b82f6', marginBottom: '30px', textAlign: 'center' }}>
                    💭 創業者の思想背景
                  </h2>
                  
                  <div style={{ marginBottom: '30px' }}>
                    <h4 style={{ color: '#f1f5f9', marginBottom: '15px' }}>時代認識</h4>
                    <p style={{ color: '#cbd5e1', lineHeight: '1.6', fontSize: '16px' }}>
                      {founderPhilosophy.background}
                    </p>
                  </div>

                  <div style={{ marginBottom: '30px' }}>
                    <h4 style={{ color: '#f1f5f9', marginBottom: '15px' }}>核となる信念</h4>
                    <ul style={{ color: '#cbd5e1', paddingLeft: '20px' }}>
                      {founderPhilosophy.beliefs.map((belief, index) => (
                        <li key={index} style={{ marginBottom: '10px', lineHeight: '1.6' }}>
                          {belief}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div style={{ 
                    background: 'rgba(59, 130, 246, 0.1)',
                    padding: '25px',
                    borderRadius: '12px',
                    borderLeft: '4px solid #3b82f6',
                    textAlign: 'center'
                  }}>
                    <h5 style={{ color: '#3b82f6', marginBottom: '15px' }}>座右の銘</h5>
                    <p style={{ color: '#f1f5f9', fontSize: '18px', fontWeight: '600', marginBottom: '10px' }}>
                      "{founderPhilosophy.quote}"
                    </p>
                    <p style={{ color: '#94a3b8', fontSize: '14px', fontStyle: 'italic' }}>
                      - 杉本迅（取締役COO）
                    </p>
                  </div>
                </div>

                {/* 人生の公式 */}
                <div className="premium-card" style={{ 
                  padding: '40px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px'
                }}>
                  <h3 style={{ color: '#3b82f6', marginBottom: '20px', textAlign: 'center' }}>
                    🧮 人生の数式
                  </h3>
                  <div style={{ 
                    background: 'rgba(15, 23, 42, 0.8)',
                    padding: '30px',
                    borderRadius: '8px',
                    fontFamily: 'monospace',
                    textAlign: 'center',
                    marginBottom: '20px'
                  }}>
                    <div style={{ color: '#cbd5e1', fontSize: '16px', lineHeight: '1.8' }}>
                      人生<sub>Jin</sub> = [∏<sub>p∈P</sub>(好奇心<sub>p</sub> + 挑戦<sub>p</sub>)/(1+挫折<sub>p</sub>)]<sup>1/|P|</sup>
                      <br />
                      × (Σ<sub>j=1</sub><sup>N</sup>Δ<sub>j</sub>) × e<sup>起業+創造性</sup>
                    </div>
                  </div>
                  <p style={{ color: '#94a3b8', fontSize: '14px', textAlign: 'center', fontStyle: 'italic' }}>
                    「好奇心と挑戦を積み重ね、起業と創造性で指数関数的成長を目指す」
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* CTA */}
      <section style={{ 
        padding: '80px 0',
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <h2 style={{ color: 'white', marginBottom: '20px' }}>
                私たちの理念に共感していただけましたか？
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '30px', fontSize: '18px' }}>
                AIを日常に、そして日本の経済成長を加速させる<br />
                この壮大なビジョンを一緒に実現しましょう。
              </p>
              <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
                <a href="/contact" className="btn btn-custom btn-lg" style={{ 
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: '2px solid white',
                  color: 'white'
                }}>
                  💬 私たちと話してみる
                </a>
                <a href="/careers" className="btn btn-custom btn-lg" style={{ 
                  background: 'white',
                  border: '2px solid white',
                  color: '#1e40af'
                }}>
                  🚀 共に働く仲間になる
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default MissionVisionPage; 